import type { HTMLAttributes } from 'react';
import styled from 'styled-components';
import { Typography } from '@elfsight/widget-ui';
import { useSettings } from '@wu/widget-core';
import { CAPTION_BOLD_STYLE } from './typography';

export function LinkButton({
  children,
  ...forwardingProps
}: HTMLAttributes<HTMLDivElement>) {
  const { accentColor } = useSettings();

  return (
    <Container
      textStyle={CAPTION_BOLD_STYLE}
      color={accentColor}
      {...forwardingProps}
    >
      {children}
    </Container>
  );
}

const Container = styled(Typography)`
  text-decoration: underline;
  cursor: pointer;
`;
